import * as React from 'react';
import classes from './MenuButton.module.scss';
import classNames from 'classnames';

type MenuButtonProps = {
  content: string;
  isActive: boolean;
  onClick?: () => void;
  isDisabled?: boolean;
};

const MenuButton = ({
  content,
  isActive,
  onClick,
  isDisabled,
}: MenuButtonProps) => {
  return (
    <button
      className={classNames(classes.menuButton, {
        [classes.active]: isActive,
        [classes.isDisabled]: isDisabled,
      })}
      onClick={onClick}
      disabled={isDisabled}
    >
      <h3
        className={classNames(classes.menuButtonText, {
          [classes.active]: isActive
        })}>
        {content}
      </h3>
    </button>
  );
};
export default MenuButton;
